module.exports = __webpack_public_path__ + "img/ContactBook.2e955c5b.svg";